// extracted by mini-css-extract-plugin
module.exports = {"taskWarp":"style_taskWarp__2R_UZ","taskTitle":"style_taskTitle__2V5ID","taskTable":"style_taskTable__1kA2J","pagination":"style_pagination__2DiPM"};